import React, { useState } from "react";
import { useDispatch } from "react-redux";

import {
  Box,
  Button,
  Collapse,
  IconButton,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@material-ui/core";

import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import IconEstado from '../../../../autorizaciones/UI/IconEstado';
import AnnouncementIcon from '@material-ui/icons/Announcement';

import { 
  getTraerSolicitudPorIdSolicitud, 
} from '../../../../../actions/autorizaciones/Autorizaciones';

import { 
  AUTORIZACIONES_SOLICITUDES_ESTADOS, 
  TIPOS_AUTORIZACIONES 
} from '../../../../../utils/constants';

import { ModalAuditar } from '../../../../autorizaciones/gestionAuditoria/ModalAuditar';
import { PracticaItem } from '../../../../autorizaciones/gestionAuditoria/PracticaItem';
import SeguimientoSolicitud from '../../../../autorizaciones/gestionAuditoria/SeguimientoSolicitud';
import { ModalHistorialCambios } from '../../../../autorizaciones/gestionAuditoria/ModalHistorialCambios';

import { CheckCircleIcon } from "@material-ui/data-grid";
import InfoHistorialIcon from '../../../../autorizaciones/UI/InfoHistorialIcon';

const useRowStyles = makeStyles({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
  },
});

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};

export const SolicitudesProfesionaItem = (props) => {
  const dispatch = useDispatch();
  const { item, estadoSolicitudes } = props;
  const [open, setOpen] = useState(props.expandirPracticas);
  const [soloVisualizacion, setSoloVisualizacion] = useState(true);
  const [openModalAuditar, setOpenModalAuditar] = useState(false);
  const [openModalHistorialCambios, setOpenModalHistorialCambios] = useState(false);
  const classes = useRowStyles();

  return (
    <>
      {openModalAuditar && (
        <ModalAuditar
          open={openModalAuditar}
          closeModalHandler={() => {
            setOpenModalAuditar(false);
          }}
          solicitud={item}
          disabled={soloVisualizacion}
          permisoIngresoInterDom={props.permisoIngresoInterDom}
          filtros={props.filtros}
          seguimiento={false}
          setRedirect={props.setRedirect}
        />
      )}
      {openModalHistorialCambios && (
        <ModalHistorialCambios
          open={openModalHistorialCambios}
          closeModalHandler={() => {
            setOpenModalHistorialCambios(false);
          }}
          solicitud={item}
          titulo={`Solicitud N° ${item.idSolicitud}`}
        />
      )}
      <TableRow className={classes.root}>
        <TableCell align="center" sx={{ padding: "10px" }}>
          <InfoHistorialIcon onClick={() => setOpenModalHistorialCambios(true)} />
        </TableCell>
        <TableCell align="right">
          {item.urgente && (
            <IconEstado
              texto={"U"}
              useColorTable={true}
              descripcion={'Urgente'}
              extraMarginRight={true}
              backgroundColor={"red"}
            />
          )}
          <IconEstado
            useColorTable={true}
            texto={item?.estadosSolicitud?.letra}
            backgroundColor={item?.estadosSolicitud?.color}
            descripcion={item?.estadosSolicitud?.descripcion}
          />
        </TableCell>
        <TableCell align="center">
          {parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.EN_CARGA /*||
          parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE_EVALUACION_APP_HCE*/
            ? new Date(item.fecha).toLocaleString("es", optionsfecha)
            : parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.TERMINADA
              ? new Date(item.fechaEgreso).toLocaleString("es", optionsfecha)
              : parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE_MATERIALES
                ? new Date(item.fechaDerivacion).toLocaleString("es", optionsfecha)
                : (item.fechaEnviada !== null ? new Date(item.fechaEnviada).toLocaleString("es", optionsfecha) : "")
          }
        </TableCell>
        <TableCell align="left">{item.idSolicitud}</TableCell>
        <TableCell align="left">{item.tipoSolicitud.descripcionTipo}</TableCell>
        <TableCell align="left">{item.conInternacion ? 'SI' : 'NO'}</TableCell>
        <TableCell align="left">{item.diagnostico?.problema}</TableCell>
        <TableCell>
          {item.practicas.length > 0 && (
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => {
                if (!open)
                  dispatch(getTraerSolicitudPorIdSolicitud(item.idSolicitud, item.idEstadoSolicitud, false, null, setOpen(!open)));
                else
                  setOpen(!open)
              }}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          )}
        </TableCell>
        <TableCell align="left">{(item.idMotivoInternacion && item.idMotivoInternacion !== 4) ? 'SI' : 'NO'}</TableCell>
        <TableCell align="left">{item.efectorGeneracion?.nombreEfector}</TableCell>
        {/* <TableCell align="left">{item.afiliado?.apellido_y_nombre}</TableCell>
        <TableCell align="left">{item.afiliado?.carnet}</TableCell> */}
        {(parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.AUDITORIA_TERRENO ||
          parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.INTERNACION_PAIS) &&
          <TableCell align="left">{item.efectorDenunciaInternacion}</TableCell>
        }
        <TableCell align="left">
          {item.solicitudesTomadas[0]?.usuarioTomada?.userName}
        </TableCell>
        {parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.INTERNACION_DOMICILIARIA
          && <TableCell align="left">
            {(item.tienePendientePracticas || item.tienePendientePeriodos || item.tienePendienteMateriales)
              ?
                <Tooltip title='Esta solicitud tiene cambios pendientes'>
                  <AnnouncementIcon style={{ color: 'red' }} />
                </Tooltip>
              :
                ""
            }
          </TableCell>}
        {parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.OXIGENO
          && <TableCell align="left">
            {(item.tienePendientePracticasOxigeno || item.tienePendientePeriodosOxigeno || item.tienePendienteMaterialesOxigeno)
              ?
                <Tooltip title='Esta solicitud tiene cambios pendientes'>
                  <AnnouncementIcon style={{ color: 'red' }} />
                </Tooltip>
              :
                ""
            }
          </TableCell>}

        {parseInt(estadoSolicitudes) !== AUTORIZACIONES_SOLICITUDES_ESTADOS.PRACTICAS_INTERNACION &&
          <TableCell align="left">
            {item?.bandejasAutorizacion?.descripcion}
          </TableCell>
        }

        <TableCell align="left">
          {(item?.idTipoSolicitud === TIPOS_AUTORIZACIONES.ESTADIAS || item?.idTipoSolicitud === TIPOS_AUTORIZACIONES.PASAJES) 
          && item?.pasajeEstadiaAprobado
            ?
            <Tooltip title='Solicitud aprobada por Auditoría Médica'>
              <CheckCircleIcon style={{ color: 'green' }} />
            </Tooltip>
            :
            ""
          }
        </TableCell>
        {(parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.AUDITORIA_TERRENO ||
          parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.INTERNACION_PAIS ||
          parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.TERMINADA ||
          parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.INTERNACION_DOMICILIARIA) &&
          <TableCell align="left">
            <SeguimientoSolicitud
              mouseEvent
              seguimiento={item.seguimiento}
            />
          </TableCell>
        }
        <TableCell>
          {(item?.idEstadoSolicitud !== AUTORIZACIONES_SOLICITUDES_ESTADOS.DEVOLUCION &&
              item?.idEstadoSolicitud !== AUTORIZACIONES_SOLICITUDES_ESTADOS.EN_CARGA) &&
            <Button
              style={{ fontSize: "0.8rem" }}
              variant="contained"
              color="primary"
              onClick={() => {
                dispatch(getTraerSolicitudPorIdSolicitud(item.idSolicitud, item.idEstadoSolicitud, true, setSoloVisualizacion,
                  null, setOpenModalAuditar, null, null, false));
              }}
            >
              Ver
            </Button>
          }
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell
          style={{ paddingBottom: 0, paddingTop: 0, paddingLeft: 100 }}
          colSpan={11}
        >
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">
                Practicas
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Estado Práctica</TableCell>
                    <TableCell>Práctica</TableCell>
                    <TableCell align="right">Cantidad</TableCell>
                    <TableCell align="center">SURGE</TableCell>
                    <TableCell>Materiales</TableCell>
                    <TableCell>Institucion</TableCell>
                    {(item.conInternacion || item.idPrestacion) &&
                      <TableCell>Profesional</TableCell>
                    }
                  </TableRow>
                </TableHead>
                <TableBody>
                  {item.practicas.map((practica) => (
                    <PracticaItem
                      key={practica?.idCodNom?.toString()}
                      conInternacion={item.conInternacion}
                      idPrestacion={item.idPrestacion}
                      item={practica}
                      materialCotizacion={item.cotizaciones}
                      estadoSolicitud={item?.idEstadoSolicitud}
                      idTipoSolicitud={item?.idTipoSolicitud}
                      filtros={props.filtros}
                    />
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};
  